import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function DashboardHome() {
  const [stats, setStats] = useState({
    recentNewsCount: 0,
    publicationsCount: 0,
    servicesCount: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/dashboard/overview`);
        setStats((current) => ({ ...current, ...response.data }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="dashboard-shell-grid">
      <div className="dashboard-shell-card">
        <p className="dashboard-shell-card-label">Recent news items</p>
        <p className="dashboard-shell-card-value">{stats.recentNewsCount}</p>
        <p className="dashboard-shell-card-caption">
          Number of news posts created in the last 7 days.
        </p>
      </div>

      <div className="dashboard-shell-card">
        <p className="dashboard-shell-card-label">Publications</p>
        <p className="dashboard-shell-card-value">{stats.publicationsCount}</p>
        <p className="dashboard-shell-card-caption">
          Total publications currently available on the website.
        </p>
      </div>

      <div className="dashboard-shell-card">
        <p className="dashboard-shell-card-label">Services overview</p>
        <p className="dashboard-shell-card-value">{stats.servicesCount}</p>
        <p className="dashboard-shell-card-caption">
          Count of practice areas or services you surface publicly.
        </p>
      </div>
    </div>
  );
}

export default DashboardHome;

